<template>
  <div class="wlx-site-manager-wrapper">
    <header class="site-manager-head-con">
      <el-form :inline="true" size="small">
        <el-form-item>
          <el-input v-model="title" placeholder="请输标题" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-circle-plus-outline" @click="add">添加</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-delete" @click="deleteAll">删除</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- 新增活动 -->
    <el-dialog
      title="新增活动"
      v-if="addNewNoticeVisible"
      :visible.sync="addNewNoticeVisible"
      :before-close="cancel"
      width="50%"
       :append-to-body="true"
       :close-on-click-modal="false"
    >
      <div>
        <el-form ref="ruleForm" label-width="80px">
          <el-form-item label="活动标题" prop="title">
            <el-input v-model="title"></el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="siteId" filterable placeholder="请选择站点" clearable>
              <el-option
                v-for="item in SiteList"
                :key="item.Id"
                :label="item.SiteName"
                :value="item.Id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="内容">
            <Editor v-model="content" placeholder="请输入内容"/>
          </el-form-item>
          <!--<el-form-item label="新闻封面">
                 <imageUpload :url="urlAliyunOSS" :files.sync="avatorUrl" format="image"></imageUpload>
          </el-form-item>-->
          <el-form-item label="发布时间">
            <el-date-picker v-model="pulishTime" type="datetime" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间">
            <el-date-picker v-model="endTime" type="datetime" placeholder="选择日期"></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="addSchoolNews()">确 定</el-button>
      </span>
    </el-dialog>
    <!--编辑-->
    <el-dialog
      title="编辑活动"
      v-if="editNoticeVisible"
      :visible.sync="editNoticeVisible"
      :before-close="cancel"
      :append-to-body="true"
      width="50%"
      :close-on-click-modal="false"
    >
      <div>
        <el-form ref="ruleForm" label-width="80px">
          <el-form-item label="活动标题" prop="title">
            <el-input v-model="title"></el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="siteName" placeholder="请选择站点" clearable>
              <el-option
                v-for="item in SiteList"
                :key="item.Id"
                :label="item.SiteName"
                :value="item.Id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="活动内容">
            <Editor v-model="content" placeholder="请输入内容"/>
          </el-form-item>
          <!--<el-form-item label="新闻封面">
                 <imageUpload :url="urlAliyunOSS" :files.sync="avatorUrl" format="image"></imageUpload>
          </el-form-item>-->
          <el-form-item label="发布时间">
            <el-date-picker v-model="pulishTime" type="datetime" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间">
            <el-date-picker v-model="endTime" type="datetime" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="活动排序" prop="orderNumber">
            <el-input v-model="orderNumber"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="editSchoolNews()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 查看弹框 -->
    <el-dialog
      title="查看活动"
      v-if="viewNoticeVisible"
      :visible.sync="viewNoticeVisible"
      :before-close="cancel"
      width="50%"
       :append-to-body="true"
       :close-on-click-modal="false"
    >
      <div>
        <el-form ref="ruleForm" label-width="80px" disabled>
          <el-form-item label="活动标题" prop="title">
            <el-input v-model="title"></el-input>
          </el-form-item>
          <el-form-item label="活动内容">
            <Editor v-model="content" placeholder="请输入内容"/>
          </el-form-item>
          <!--<el-form-item label="新闻封面">
                 <imageUpload :url="urlAliyunOSS" :files.sync="avatorUrl" format="image"></imageUpload>
          </el-form-item>-->
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="cancel">确 定</el-button>
      </span>
    </el-dialog>

    <el-table
      ref="multipleeeeTable"
      :data="list"
      tooltip-effect="dark"
      empty-text=" "
      style="width: 100%;"
      @selection-change="handleSelectionChange"
    >
      <el-table-column prop="id" type="selection" width="55"></el-table-column>
      <el-table-column label="序号" type="index" width="50"></el-table-column>
      <el-table-column prop="title" label="活动标题" :show-overflow-tooltip="true" width="300"></el-table-column>
      <el-table-column label="内容" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <p v-html="scope.row.contentText"></p>
        </template>
      </el-table-column>
      <el-table-column prop="dateCreated" label="创建时间" width="180"></el-table-column>
      <!-- <el-table-column prop="associationName" label="创建人"></el-table-column> -->
      <el-table-column prop="orderNumber" label="排序" width="60"></el-table-column>
      <el-table-column prop="pulishTime" label="开始时间" width="180"></el-table-column>
      <el-table-column prop="endTime" label="结束时间" width="180"></el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button
            size="mini"
            class="el-icon-edit"
            @click="edit(scope.row)"
            type="primary"
            title="编辑"
          ></el-button>
          <el-button
            size="mini"
            type="primary"
            class="el-icon-view"
            @click="viewSchoolNews(scope.row)"
            title="查看"
          ></el-button>
          <el-button
            size="mini"
            type="danger"
            class="el-icon-delete"
            @click="deleteMajor(scope.row.id)"
            titlt="删除"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
     <div class="u-page-con">
       <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="onPageChangeHandler"
      :current-page="pageIndex"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      v-show="total>0"
    ></el-pagination>
     </div>
  </div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";
export default {
  data() {
    return {
      list: [],
      SiteList: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      addNewNoticeVisible: false,
      editNoticeVisible: false,
      viewNoticeVisible: false,
      /* -----------添加/修改弹框参数------------ */
      sTitle: "",
      title: "",
      content: "",
      avatorUrl: "",
      newsType: 1,
      orderNumber: 0,
      pulishTime: "",
      endTime: "",
      /* --------------------------------------- */
      id: "",
      ids: [],
      siteId: "",
      siteName: "",
      // noDataShow: false,
      value: "",
      attestationId: ""
    };
  },
  components: {
    imageUpload
  },
  created() {
    this.school = this.$store.state.auth.userName;
    this.getAttestationList();
    this.getSitesList();
  },
  methods: {
    getAttestationList(page) {
      var that = this;
      this.$http
        .post("/api/XOrg/AssociationAttestation/getAttestationList", {
          page: page,
          pageSize: this.pageSize,
          title: that.title,
          value: 1
        })
        .then(rst => {
          if (rst.code == 1) {
            this.list = rst.list;
            this.total = rst.pagination.totalCount;
            this.pageSize = rst.pagination.pageSize;
            this.pageIndex = rst.pagination.pageIndex;
            this.cancel();
          } else {
            this.$message.warning(rst.msg);
          }
        });
    },
    //获取站点列表
    getSitesList() {
      var that = this;
      this.$http
        .post("/api/XOrg/AssociationAttestation/getSitesList")
        .then(rst => {
          if (rst.code == 1) {
            that.SiteList = rst.siteList;
          } else {
            that.$message.warning(res.msg);
          }
        });
    },
    onPageChangeHandler(page) {
      this.getAttestationList(page);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getAttestationList();
    },
    handleSelectionChange(val) {
      this.ids = [];
      val.forEach(element => {
        this.ids.push(element.Id);
      });
    },
    cancel() {
      (this.addNewNoticeVisible = false),
        (this.editNoticeVisible = false),
        (this.viewNoticeVisible = false),
        (this.siteId = ""),
        (this.title = ""),
        (this.content = ""),
        (this.avatorUrl = "");
      this.newsType = 1;
      this.pulishTime = "";
      this.endTime = "";
    },
    addSchoolNews() {
      var that = this;
      this.$http
        .post("/api/XOrg/AssociationAttestation/addAttestation", {
          title: that.title,
          content: that.content,
          pulishTime: that.pulishTime,
          endTime: that.endTime,
          siteId: that.siteId,
          type: 1
        })
        .then(rst => {
          if (rst.code === 1) {
            that.cancel();
            that.$message({
              showClose: true,
              message: rst.msg,
              type: "success"
            });
            that.getAttestationList();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    viewSchoolNews(row) {
      this.title = row.title;
      this.content = row.content;
      this.viewNoticeVisible = true;
    },
    editSchoolNews() {
      var that = this;
      this.$http
        .post("/api/XOrg/AssociationAttestation/editAttestation", {
          attestationId: that.attestationId,
          title: that.title,
          content: that.content,
          pulishTime: that.pulishTime,
          endTime: that.endTime,
          orderNumber: that.orderNumber,
          siteId: that.siteId
        })
        .then(rst => {
          if (rst.code === 1) {
            that.cancel();
            that.$message({
              message: rst.msg,
              type: "success"
            });
            that.editNoticeVisible = false;
            that.getAttestationList();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    add() {
      this.addNewNoticeVisible = true;
    },
    edit(row) {
      this.editNoticeVisible = true;
      this.title = row.title;
      this.content = row.content;
      this.attestationId = row.id;
      this.orderNumber = row.orderNumber;
      this.pulishTime = row.pulishTime;
      this.endTime = row.endTime;
      this.siteName = row.siteName;
      this.siteId = row.siteId;
    },
    deleteMajor(id) {
      this.$confirm("此操作将删除该活动, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // this.DeleteSchoolNews(id)
          var that = this;
          this.$http
            .post("/api/XOrg/AssociationAttestation/deleteAttestation", {
              attestationIds: id
            })
            .then(rst => {
              if (rst.code === 1) {
                that.$message({
                  message: rst.msg,
                  type: "success"
                });
                that.getAttestationList();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    search() {
      this.getAttestationList(1);
    },
    deleteAll() {
      if (this.ids.length === 0) {
        this.$message({
          showClose: true,
          message: "请选择活动",
          type: "warning"
        });
        return false;
      }
      this.$confirm("此操作将删除所选活动, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // DeleteSchoolNews(this.ids)
          var that = this;
          this.$http
            .post("/api/XOrg/AssociationAttestation/deleteAttestation", {
              attestationIds: that.ids
            })
            .then(rst => {
              if (rst.code === 1) {
                this.$message({
                  message: rst.msg,
                  type: "warning"
                });
                this.getAttestationList();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
};
</script>
